export const CLOSE_ERROR_CODE = 'CLOSE_ERROR_CODE'
